module.exports = __webpack_public_path__ + "static/media/YM21_2.f1442e5c.jpg";